"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Match = _interopRequireDefault(require("./Match"));

var Matcher = /*#__PURE__*/function () {
  function Matcher(text) {
    (0, _classCallCheck2["default"])(this, Matcher);
    this.text = text || '';
    this.matches = [];
    this.currentMark = '';
    this.currentStart = 0;
    this.markers = {
      '~': 'sub',
      '^': 'sup'
    };
    this.find();
  }

  (0, _createClass2["default"])(Matcher, [{
    key: "find",
    value: function find() {
      for (var i = 0; i < this.text.length; i += 1) {
        var match = this.markers[this.text[i]];

        if (match) {
          if (this.currentMark === this.text[i]) {
            this.matches.push(new _Match["default"](this.currentStart, i, this.markers[this.currentMark]));
            this.reset();
          } else {
            this.currentMark = this.text[i];
            this.currentStart = i;
          }
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.currentMark = '';
      this.currentStart = 0;
    }
  }]);
  return Matcher;
}();

var _default = Matcher;
exports["default"] = _default;